









import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
})

export default class SFSelect extends Vue {
    @Prop({}) data: any;
    @Prop({}) selected: any;
    @Prop({ }) value: any;

    isSelected(option) {
        if (typeof this.value !== 'undefined') {
            if (this.value === option.id) return true
        } else return option.isDefaultAnswer;
    }
}
